module.exports = __webpack_public_path__ + "img/DASHU-FPD.63cf4112.png";